import React from "react";
import { Label } from "semantic-ui-react";
import PropTypes from "prop-types";

const stateIcons = {
  validated: {
    label: "Quality Checks Passed",
    color: "green",
  },
  error: {
    label: "Quality Checks failed",
    color: "red",
  },
  draft: {
    label: "Draft",
    color: "blue",
  },
  published: {
    label: "Published",
    color: "green",
  },
  submitted: {
    label: "Publication requested",
    color: "yellow",
  },
  running: {
    label: "Quality Checks running",
    color: "blue",
  },
  declined: {
    label: "Publication declined",
    color: "red",
  },
};

export function StateIcon({ state }) {
  const iconProps = stateIcons[state] || {};
  return (
    <Label color={iconProps.color} ribbon>
      {iconProps.label}
    </Label>
  );
}

StateIcon.defaultProps = {
  state: PropTypes.string.isRequired,
};
